import React from "react";
import PropTypes from "prop-types";
import RouterContext from "../contexts/RouterContext";
import useOnHistoryPopstate from "../hooks/use-on-history-popstate";
import RouterHelper from "../helpers/RouterHelper";
import RouteContext from "../contexts/RouteContext";
import PushCurrentRouteToHistory from "../helpers/PushCurrentRouteToHistory";

function Router(props) {

    const router = new RouterHelper();

    router.components = props.components;

    useOnHistoryPopstate(state => {
        if (state.state && state.state.route && state.state.parameters) {
            router.navigate(state.state.route, state.state.parameters);
        }
    });

    return (
        <RouterContext.Provider value={router}>
            <RouteContext.Provider value={router.current}>
                <PushCurrentRouteToHistory/>
                {props.children}
            </RouteContext.Provider>
        </RouterContext.Provider>
    );
}

Router.defaultProps = {
    initialParameters: {},
    components: {},
};

Router.propTypes = {
    initialParameters: PropTypes.object,
    components: PropTypes.object.isRequired,
};

export default Router;
